import { Controller } from "@hotwired/stimulus"

// UI-04 channel toggle (Plan 04-08).
//
// Pattern: URL state-as-source-of-truth. Clicking a channel button mutates
// `?channels[]=` then triggers a Turbo navigation so the controller refreshes
// @selected_channels + @chart_series server-side. MVP keeps things simple — no
// in-place Chartkick `.update()`; full nav is fast enough at our scale and
// guarantees the multi-axis dataset bindings stay deterministic.
//
// Auto-registered via the `controllers/index.js` esbuild glob (do NOT edit
// index.js — LOCK from plan 04-02).
//
// Values:
//   selected — current channel keys (Array<string>), seeded by view from
//              @selected_channels on first render
//
// Action: toggle (button click)
//   - Receives the channel key via `data-channel-toggle-channel-param="<ch>"`.
//   - Adds/removes from the set, drops empty-set updates (UX guard: at least
//     one channel must remain — otherwise the chart has no series at all).
export default class extends Controller {
  static values = { selected: Array }

  toggle(event) {
    const channel = event.params.channel
    if (!channel) return

    const set = new Set(this.selectedValue)
    if (set.has(channel)) {
      set.delete(channel)
    } else {
      set.add(channel)
    }
    const next = Array.from(set)
    if (next.length === 0) return // UX guard — keep at least one channel

    const url = new URL(window.location.href)
    url.searchParams.delete("channels[]")
    next.forEach((c) => url.searchParams.append("channels[]", c))

    // Use Turbo navigation when available, fall back to standard nav.
    if (window.Turbo && typeof window.Turbo.visit === "function") {
      window.Turbo.visit(url.toString())
    } else {
      window.location.assign(url.toString())
    }
  }
}
